import { IAccountExperienceParams } from '@aqx-core/common/api/account-experience';

export enum EResetPasswordExperienceContent {
  FORM = 'FORM',
  COMPLETE = 'COMPLETE'
}

export interface IResetPasswordParams {
  params: IAccountExperienceParams;
  onError: (message: string) => void;
}
